import { Settings } from '@mui/icons-material';
import React from 'react';

import { useUserOrgId } from '../../auth/authentication';
import { TerritorySimple } from '../../fetching/sharedSchemas/basicSchemas';
import { orgPrefixedName } from '../../utils/formatting';
import { InputState } from '../../utils/inputState';
import { openInNewTab } from '../../utils/links';
import { ReturnComponent } from '../../utils/reactTypes';
import { AxleIconButton } from '../buttons/AxleIconButton';
import { AxleAutocompleteMultiselectWithShortChips } from './multiselectFields';

export const TerritoriesField = ({
    label = 'Territories',
    enabled = true,
    inputState,
    options,
}: {
    label?: string;
    enabled?: boolean;
    inputState: InputState<string[]>;
    options: TerritorySimple[];
}): ReturnComponent => {
    const userOrgId = useUserOrgId();
    const showOrgColumn = options.some((territory) => territory.organization.uuid !== userOrgId);

    return (
        <AxleAutocompleteMultiselectWithShortChips
            label={label}
            enabled={enabled}
            inputState={inputState}
            options={options}
            optionToValue={(territory) => territory.uuid}
            optionToLabel={(territory) => orgPrefixedName(territory, showOrgColumn)}
            trailingButtons={
                <AxleIconButton
                    icon={<Settings />}
                    tooltip={'Manage Territories'}
                    onClick={() => openInNewTab('/territories')}
                />
            }
        />
    );
};
